import Bowser from 'bowser';
import fileSaver from 'file-saver';
import ical from 'ical-generator';

export default {
  convertRawQuantityToNumber(rawQuantity) {
    if (rawQuantity === '') return 0;
    if (!rawQuantity) return null;
    return Number(rawQuantity.split(/[.,]/)[0]);
  },
  convertFileToBase64(file, fullBase64 = true) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (!fullBase64) {
          const res = reader.result.split(';base64,');
          resolve(res[1]);
        } else {
          resolve(reader.result);
        }
      };
      reader.onerror = error => reject(error);
    });
  },
  clusterizeMedia(documents, filenameProp = 'filename') {
    const imagesRegex = /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i;
    const docsRegex = /\.(doc|pdf)$/i;
    return documents.reduce((acc, item) => {
      if (imagesRegex.test(item[filenameProp])) return { ...acc, images: [...acc.images, item] };
      else if (docsRegex.test(item[filenameProp])) return { ...acc, docs: [...acc.docs, item] };
      return acc;
    }, { images: [], docs: [] });
  },
  getFileExtension(fileName) {
    return (fileName.match(/\.[0-9a-zA-Z]+$/) || [])[0] || '';
  },
  removeFileExtension(file) {
    return (file.name.split('.').slice(0, -1).join('.')) || '';
  },
  removeBase64Header(file) {
    const base64Splitted = file.split(';base64,');
    return base64Splitted[1];
  },
  openFileFromBase64(base64Data, mimeType) {
    const base64ToBlob = (base64, type = 'application/octet-stream') => {
      // TODO: fix like downloadMediaFromBase64
      // atob deprecated!
      const binStr = atob(base64);
      const len = binStr.length;
      const arr = new Uint8Array(len);
      [...Array(len)].forEach((el, index) => {
        arr[index] = binStr.charCodeAt(index);
      });
      return new Blob([arr], { type });
    };
    const blob = base64ToBlob(base64Data, mimeType);
    const url = URL.createObjectURL(blob);

    const isSafari =
      navigator.vendor &&
      navigator.vendor.indexOf('Apple') > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf('CriOS') === -1 &&
      navigator.userAgent.indexOf('FxiOS') === -1;
    if (isSafari) {
      const link = document.createElement('a');
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.click();
    }
    // window.open(url);
    // const pdfWindow = window.open('');
    // pdfWindow.document.write(`<iframe width='100%' height='100%' src='${url}'></iframe>`);
  },
  camelizeString(str) {
    const arr = str.split('-');
    const capital = arr.map((item, index) =>
      (index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item));
    return capital.join('');
  },
  obfuscateEmail(email) {
    const obfuscateString = str => str.split('').reduce((acc, c, index) => (index > 0 ? `${acc}*` : acc + c), '');
    const splittedEmail = email.split('@');
    const firstPart = obfuscateString(splittedEmail[0]);
    const domainParts = splittedEmail[1].split(/\.(.+)/);
    const secondPart = obfuscateString(domainParts[0]);
    return `${firstPart}@${secondPart}.${domainParts[1]}`;
  },
  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`;
  },
  isValidBrowser() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    return browser.getBrowserName() !== 'Internet Explorer';
  },
  downloadMediaFromBase64(base64Data, fileName, mimeType) {
    const base64ToBlob = (base64, type = 'application/octet-stream') => {
      // atob deprecated!
      // const binStr = atob(base64);
      // const len = binStr.length;
      // const arr = new Uint8Array(len);
      // [...Array(len)].forEach((el, index) => {
      //   arr[index] = binStr.charCodeAt(index);
      // });
      // return new Blob([arr], { type });
      const binStr = Buffer.from(base64, 'base64');
      return new Blob([binStr], { type });
    };
    const blob = base64ToBlob(base64Data, mimeType);
    fileSaver.saveAs(blob, fileName);
  },
  createCalendarFile({
    name, start, summary, description,
  }) {
    const calendar = ical({ name });
    calendar.createEvent({
      start,
      summary,
      description,
    });
    return calendar;
  },
};
